var map = {
	"./artifacts.yaml": 7341,
	"./info.yaml": 6936,
	"./intro.yaml": 6782,
	"./news.yaml": 5256,
	"./pubList.yaml": 1271,
	"./pubs/backstage.yaml": 3906,
	"./pubs/clams.yaml": 5362,
	"./pubs/clever.yaml": 4728,
	"./pubs/clm.yaml": 9102,
	"./pubs/clochat.yaml": 6024,
	"./pubs/clustersense.yaml": 5158,
	"./pubs/dabrush.yaml": 5960,
	"./pubs/dadr.yaml": 9058,
	"./pubs/drbias.yaml": 444,
	"./pubs/exif.yaml": 597,
	"./pubs/fourdomains.yaml": 2827,
	"./pubs/githru.yaml": 8080,
	"./pubs/harmful.yaml": 5200,
	"./pubs/iolens.yaml": 2622,
	"./pubs/issue_propagation.yaml": 8737,
	"./pubs/ltgm.yaml": 7599,
	"./pubs/ltnc.yaml": 7378,
	"./pubs/metricselection.yaml": 8651,
	"./pubs/misannot.yaml": 2254,
	"./pubs/misusing.yaml": 3531,
	"./pubs/monetexplorer.yaml": 1824,
	"./pubs/navigating.yaml": 6879,
	"./pubs/phenoflow.yaml": 7134,
	"./pubs/snc.yaml": 5807,
	"./pubs/template.yaml": 994,
	"./pubs/therapist.yaml": 1317,
	"./pubs/umato.yaml": 7990,
	"./pubs/umatofull.yaml": 949,
	"./pubs/vant.yaml": 7024,
	"./pubs/vl2nl.yaml": 7052,
	"./pubs/vnli.yaml": 1895,
	"./pubs/zadu.yaml": 6801,
	"./software.yaml": 9532
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5186;